import React, { ReactNode } from 'react';

export type ToolTipPlacement =
    | 'none'
    | 'top'
    | 'top-end'
    | 'top-start'
    | 'right'
    | 'bottom'
    | 'bottom-end'
    | 'bottom-start'
    | 'left';

interface ITooltipProps {
    // slots
    label: string | ReactNode;
    description: string;
    // attributes
    analytics?: string;
    dark?: boolean;
    placement?: ToolTipPlacement;
    // extra nous
    dataTestId?: string;
    onClick?: () => void;
}

export const Tooltip: React.FC<ITooltipProps> = ({
    // slots
    label,
    description,
    // attributes
    analytics,
    dark = false,
    placement = 'bottom',
    // extra nous
    dataTestId,
    onClick
}) => {
    return (
        <>
            <div onClick={onClick}>
                {/* @ts-ignore */}
                <dsd-tooltip
                    analytics={analytics}
                    data-testid={dataTestId}
                    placement={placement}
                    dark={dark}
                >
                    <span slot="description">{description}</span>
                    <span slot="label">{label}</span>
                    {/* @ts-ignore */}
                </dsd-tooltip>
            </div>
        </>
    );
};
